import {ValueObject} from '@s-ui/domain'

export class LatestPlatesValueObject extends ValueObject {
  #lastPlate
  #platesByDate
  #date
  #stats

  constructor({lastPlate, plates, date, stats}) {
    super()

    this.#lastPlate = lastPlate
    this.#platesByDate = plates
    this.#date = date
    this.#stats = stats
  }

  static validate({lastPlate}) {
    if (!lastPlate) {
      throw new Error('[LatestPlatesValueObject#validate] lastPlate is required')
    }
  }

  static create({lastPlate, plates, date, stats}) {
    LatestPlatesValueObject.validate({lastPlate})
    return new LatestPlatesValueObject({lastPlate, plates, date, stats})
  }

  get lastPlate() {
    return this.#lastPlate
  }

  get platesByDate() {
    return [...this.#platesByDate]
  }

  get date() {
    return this.#date
  }

  get stats() {
    return {...this.#stats}
  }

  toJSON() {
    return {
      lastPlate: this.#lastPlate,
      platesByDate: [...this.#platesByDate],
      date: this.#date,
      stats: {...this.#stats}
    }
  }
}
